import { Box } from '@mui/material';

const TrendDownIcon = () => (
  <Box sx={{ transform: 'rotate(180deg) translate(0px, 2px)' }}>
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M5.5 17.75C5.34664 17.7501 5.19692 17.7032 5.07104 17.6156C4.94516 17.528 4.84916 17.4039 4.79598 17.2601C4.7428 17.1162 4.73499 16.9595 4.77362 16.8111C4.81225 16.6627 4.89544 16.5297 5.012 16.43L12.012 10.43C12.1479 10.3135 12.321 10.2495 12.5 10.2495C12.679 10.2495 12.8521 10.3135 12.988 10.43L19.988 16.43C20.1046 16.5297 20.1878 16.6627 20.2264 16.8111C20.265 16.9595 20.2572 17.1162 20.204 17.2601C20.1508 17.4039 20.0548 17.528 19.929 17.6156C19.8031 17.7032 19.6534 17.7501 19.5 17.75H5.5Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.93 13.488C4.99413 13.5628 5.07237 13.6243 5.16026 13.6688C5.24815 13.7134 5.34396 13.7402 5.44221 13.7477C5.54047 13.7553 5.63924 13.7434 5.73289 13.7127C5.82654 13.682 5.91323 13.6332 5.988 13.569L12.5 7.988L19.012 13.569C19.0861 13.6369 19.1732 13.6892 19.268 13.7228C19.3627 13.7564 19.4633 13.7706 19.5637 13.7645C19.664 13.7585 19.7621 13.7323 19.8522 13.6876C19.9422 13.6428 20.0224 13.5805 20.0878 13.5041C20.1533 13.4278 20.2027 13.3391 20.2332 13.2433C20.2637 13.1475 20.2746 13.0465 20.2653 12.9464C20.256 12.8463 20.2266 12.7491 20.179 12.6605C20.1314 12.572 20.0664 12.4939 19.988 12.431L12.988 6.431C12.8521 6.31453 12.679 6.25052 12.5 6.25052C12.321 6.25052 12.1479 6.31453 12.012 6.431L5.012 12.431C4.86118 12.5605 4.76794 12.7445 4.75275 12.9427C4.73756 13.1409 4.80167 13.337 4.931 13.488H4.93Z"
        fill="#FF0000"
      />
    </svg>
  </Box>
);

export default TrendDownIcon;
